import Badge from 'components/badge/Badge';
import Button from 'components/button/Button';
import styled from 'styled-components';
import theme from 'styles/theme';

export const StyledBadge = styled(Badge)<{ isActive: boolean }>`
  background-color: ${({ isActive }) =>
    isActive ? theme.colors.bgGreen : theme.colors.gray500};

  &:hover {
    background-color: ${({ isActive }) =>
      isActive ? theme.colors.primary : theme.colors.gray500};
  }
`;

export const StyledButton = styled(Button)`
  padding: 0;
  position: relative;
  padding-right: 15px;

  .pencil-square-icon {
    position: absolute;
    visibility: hidden;
  }

  &:hover {
    .pencil-square-icon {
      visibility: visible;
      top: 3px;
      margin-left: 3px;
    }
  }

  &:focus,
  &:active:focus {
    border: none;
    outline: none;
  }
`;
